import React, { useState, useEffect, useRef } from 'react';
import './AIIntelligence.css';
import aiLogo from '../../assets/images/ailogo.svg';
import aiFeature1 from '../../assets/images/ai11.svg';
const AIIntelligence = () => {
    const [isVisible, setIsVisible] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            {
                threshold: 0.3,
                rootMargin: '0px 0px -50px 0px'
            }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <div className="ai-intelligence-container" ref={containerRef}>
            {/* Header Section */}
            <div className="ai-header">
                <div className={`ai-badge ${isVisible ? 'animate-fade-in' : ''}`}>
                    <img src={aiLogo} alt="AI Enhancements" className="ai-badge-icon" />
                </div>
                
                <h1 className={`ai-title ${isVisible ? 'animate-slide-up delay-200' : ''}`}>
                    Harness AI to Automate and<br />
                    Elevate Your Asset Library.
                </h1>
                
                <p className={`ai-subtitle ${isVisible ? 'animate-slide-up delay-400' : ''}`}>
                    Let artificial intelligence take the heavy lifting out of tagging, finding, and recognising digital content.
                </p>
            </div>

            {/* AI Features Section */}
            <div className={`ai-features ${isVisible ? 'animate-slide-up delay-600' : ''}`}>
                <img src={aiFeature1} alt="AI Feature 1" className="ai-feature-image" />
            </div>
        </div>
    );
};

export default AIIntelligence; 